var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParseForm',{ref:"base",attrs:{"formParams":_vm.formParams,"formId":"formParams.formId","opCode":_vm.opCode,"funcClick":_vm.bindClickEvent,"funcOnChange":_vm.onChangeEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }